import {CSSProperties, FC} from 'react';


export interface IIconOfferBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconOfferBmw: FC<IIconOfferBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m20.962 9.94-.79 2.06.79 2.06a.562.562 0 0 1-.17.638l-1.713 1.387-.346 2.18a.564.564 0 0 1-.468.467l-2.18.347L14.7 20.79a.56.56 0 0 1-.64.172L12 20.173l-2.059.789a.56.56 0 0 1-.639-.171l-1.388-1.712-2.179-.347a.562.562 0 0 1-.466-.468l-.347-2.179-1.713-1.387a.561.561 0 0 1-.171-.638l.79-2.06-.79-2.06a.563.563 0 0 1 .17-.637l1.714-1.388.347-2.18a.564.564 0 0 1 .466-.466l2.18-.346 1.387-1.714a.561.561 0 0 1 .638-.17l2.06.79 2.06-.792a.563.563 0 0 1 .639.171l1.387 1.713 2.179.347c.24.038.43.226.468.467l.346 2.179 1.712 1.388c.19.154.258.412.171.639ZM12 9.189a1.69 1.69 0 0 0-1.687-1.687 1.69 1.69 0 0 0-1.688 1.687c0 .93.757 1.688 1.688 1.688A1.69 1.69 0 0 0 12 9.188Zm0 5.625c0 .93.757 1.687 1.687 1.687a1.69 1.69 0 0 0 1.688-1.687 1.69 1.69 0 0 0-1.688-1.687A1.69 1.69 0 0 0 12 14.813Zm-2.354 1.452L15.27 8.39a.562.562 0 1 0-.915-.654L8.73 15.611a.562.562 0 1 0 .915.654Zm.667-6.514a.562.562 0 1 0 0-1.125.562.562 0 0 0 0 1.125Zm3.374 5.624a.562.562 0 1 0 0-1.124.562.562 0 0 0 0 1.124Z" clipRule="evenodd" />
        </svg>
    );
};
